export default {
  heading: {
    widgetName: "Merchant List",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `MerchantList | Partners`,
      eventLabelCardClick: `MerchantList | {{cardtitle}}  | {{cardposition}}`,
      eventLabelHeadlineClick: `MerchantList | headline | {{headline}}`,
      eventLabelView: `MerchantList`,
    },
  },

  data: [
   {
        "title": "Santan",
        "image": "https://www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/santan.jpeg",
        "url": "https://www.airasia.com/aa/restaurant-lists/santan-delivery"
      },
      {
        "title": "Sugar & i",
        "image": "https://www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/Sugar-I.png",
        "url": "https://www.airasia.com/aa/restaurant-lists//sugar-i-delivery"
      },
      {
        "title": "Tealive",
        "image": "https://www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/Tealive.png",
        "url": "https://www.airasia.com/aa/restaurant-lists/tealive-delivery"
      },
      {
        "title": "KFC",
        "image": "https://www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/kfc.jpg",
        "url": "https://www.airasia.com/aa/restaurant-lists/kfc-delivery"
      },
      {
        "title": "Kubis & Kale",
        "image": "https://www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/kubis-kale.jpg",
        "url": "https://www.airasia.com/aa/restaurant-lists/kubis-kale-delivery"
      },
      {
        "title": "TNR by Sean & Angie ",
        "image": "https://www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/tnr.jpg",
        "url": "https://www.airasia.com/aa/restaurant-lists/tnr-delivery"
      },
      {
        "title": "Paradise Dynasty",
        "image": "https://www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/paradise-dynasty.jpg",
        "url": "https://www.airasia.com/aa/restaurant-lists/paradise-dynasty-delivery"
      },
      {
        "title": "Para Thai",
        "image": "https://www.airasia.com/aa/images/web-apps/food-merchant/merchant-logo/para-thai.jpg",
        "url": "https://www.airasia.com/aa/restaurant-lists/para-thai-delivery"
      }
    ],
  }
  